import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';
import classNames from 'classnames';
import OutsideClickHandler from 'react-outside-click-handler';

// ---------------------------------------------------------

import Icon from '@components/icon';

// ---------------------------------------------------------

import styles from './styles.module.scss';
const {
  sort_button,
  dropdown_content_inner,
  dropdown_container,
  dropdown_is_showing,
  dropdown_content,
  options_container
} = styles;

// ---------------------------------------------------------

const SortButton = ({ options, onChange, selection }) => {
  const [dropdownIsOpen, setDropdownIsOpen] = useState(false);

  // ---------------------------------------------------------

  const handleOptionClick = (option) => {
    onChange(option);
  };

  const handleOptionKeyDown = (e, option) => {
    if (e.key === 'Enter') onChange(option);
  };

  // ---------------------------------------------------------

  const getDropdownContainer = () => {
    return (
      <ul className={options_container}>
        {options.length > 0 &&
          options.map((option, idx) => {
            return (
              <li
                role="option"
                aria-selected={selection === option.label}
                tabIndex={-1}
                key={`${option.label}-${idx}`}
                value={option.value}
                onClick={() => handleOptionClick(option)}
                onKeyDown={(e) => handleOptionKeyDown(e, option)}
              >
                {option.label}
              </li>
            );
          })}
      </ul>
    );
  };

  // ---------------------------------------------------------

  return (
    <div
      className={classNames(dropdown_container, {
        [dropdown_is_showing]: dropdownIsOpen
      })}
    >
      <OutsideClickHandler onOutsideClick={() => setDropdownIsOpen(false)}>
        <button
          aria-expanded={dropdownIsOpen}
          aria-controls="sort-by"
          className={sort_button}
          onClick={() => setDropdownIsOpen(true)}
        >
          <Icon name="sort-by" type="actions" />
          {selection?.label || 'Sort by'}
        </button>

        <AnimateHeight
          animateOpacity={true}
          className={dropdown_content}
          contentClassName={dropdown_content_inner}
          duration={400}
          height={dropdownIsOpen ? 'auto' : 0}
          id="sort-by"
        >
          {getDropdownContainer()}
        </AnimateHeight>
      </OutsideClickHandler>
    </div>
  );
};

SortButton.propTypes = {
  /**
   * Specifies an action when on of the sort options is selected
   */
  onChange: PropTypes.func.isRequired,

  /**
   * Specifies the options of the select.
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any
    })
  ),

  /**
   * Specifies the label amd value for the current selection
   */
  selection: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.any
  })
};

export default SortButton;
